export default "__VITE_ASSET__b22b0269__"